import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Filter, QueryGet } from '../../types/query-types';
import { PAGINATION } from '../../constants/constants';
import { Pagination } from '../../models/pagination.interface';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  toastr = inject(ToastrService);
  constructor(
    private http: HttpClient,
    private router: Router,
  ) {}

  /**
   * response handler for generic crud responses
   * @param recordName entity record name or id ex: 'sercretario'
   * @param redirectTo if reuest is success will redirect here by default is 'inicio
   * @param action text action will show on messge 'actulizado', 'eliminado' by default is 'creado'
   * @returns observable object handler
   * @author chatuz
   */
  resHandler(recordName: string, redirectTo: string = 'inicio', action: string = 'creado') {
    return {
      next: (data: unknown) => {
        this.router.navigate([redirectTo]);
        const msg = `El registro <b>${recordName}</b> fue ${action} <b>CORRECTAMENTE!</b>`;
        this.toastr.success(msg, '¡Operación exitosa!');
      },
      error: ({ error }: HttpErrorResponse) => {
        // Convierte el objeto de errores en un string amigable
        const msg = Object.entries(error)
          .map(([key, val]) => `${key}: ${val}`)
          .join('\n');
        this.toastr.error(msg, '¡Error en la operación!');
      },
    };
  }

  get<T>(url: string, queryParams: QueryGet): Observable<Pagination<T>> {
    const params = `search=${queryParams.search}&limit=${queryParams.limit}&offset=${queryParams.offset}&ordering=${queryParams.order}`;
    const filterFields = queryParams.filters.map((filter) => {
      return `${filter.name}=${filter.value}`;
    });
    const filterParams = this.genParams(filterFields);
    const urlWithParams =
      filterParams.length > 0 ? `${url}?${params}&${filterParams}` : `${url}?${params}`;
    return this.http.get<Pagination<T>>(urlWithParams);
  }

  getAll<T>(url: string, queryParams: QueryGet): Observable<T> {
    const params = `search=${queryParams.search}&limit=${queryParams.limit}&offset=${queryParams.offset}&ordering=${queryParams.order}`;
    const filterFields = queryParams.filters.map((filter) => {
      return `${filter.name}=${filter.value}`;
    });
    const filterParams = this.genParams(filterFields);
    const urlWithParams =
      filterParams.length > 0 ? `${url}?${params}&${filterParams}` : `${url}?${params}`;
    return this.http.get<T>(urlWithParams);
  }

  genParams(params: string[]): string {
    if (params.length === 0) {
      return '';
    }
    return `${params.join('&')}`;
  }

  genDefaultParams(filters: Filter[] = [], search = ''): QueryGet {
    return {
      limit: PAGINATION.page_number,
      order: '-id',
      offset: 0,
      filters,
      search,
    };
  }

  /** Detects if given url refers to an edition path */
  hasEditPath(url: string): boolean {
    const regex = /\/api\/v1\/\w+\/\d+\/$/;
    const urlToCheck = new URL(url);
    const path = urlToCheck.pathname;
    if (regex.test(path)) {
      return true;
    }

    return false;
  }
}
